module.exports = __webpack_public_path__ + "img/dog-face.d9b71b1c.png";